







































































import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import FloatingMenu from "@/components/Molecules/FloatingMenu/index.vue";
import FloatingMenuButton from "@/components/Atoms/FloatingMenuItems/FloatingMenuButton/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import { KEYCODE } from "@/constants/event";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Heading,
    FloatingMenu,
    FloatingMenuButton,
    Body
  },
  props: {
    studentId: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    course: {
      type: String as PropType<Props["course"]>,
      required: true
    }
  },
  data() {
    return {
      floatingMenuProps: {
        isVisible: false,
        position: {
          x: 0,
          y: 0
        },
        vertexDirection: "",
        items: [
          {
            value: "edit",
            label: "編集",
            iconName: "Pen",
            disabled: false,
            isVisible: true
          },
          {
            value: "reload",
            label: "再読み込み",
            iconName: "Refresh",
            disabled: true,
            isVisible: false
          },
          {
            value: "delete",
            label: "削除",
            iconName: "Trash",
            theme: "destructive",
            disabled: false,
            isVisible: true
          }
        ]
      }
    };
  },
  computed: {
    courseName() {
      switch (this.course) {
        case "HUMANITIES":
          return "文";
        case "SCIENCE":
          return "理";
        case "UNSPECIFIED":
          return "未";
        default:
          return "";
      }
    }
  },
  mounted() {
    window.addEventListener("keyup", this.handleEsc);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.handleEsc);
  },
  methods: {
    handleEsc(event) {
      if (event.keyCode !== KEYCODE.ESC) {
        return;
      }
      this.floatingMenuProps.isVisible = false;
    },
    handleClickFloatingMenuVisible(event) {
      this.floatingMenuProps.isVisible = !this.floatingMenuProps.isVisible;
      if (
        event.currentTarget instanceof HTMLElement &&
        this.floatingMenuProps.isVisible
      ) {
        this.showFloatingMenu(event.currentTarget);
      }
    },
    showFloatingMenu(target) {
      const FLOATING_MENU_ARROW_MARGIN = -2;
      const FLOATING_MENU_ARROW_HEIGHT = 8;
      const FLOATING_MENU_CONTENT_PADDING = 14;
      const FLOATING_MENU_CONTENT_WIDTH = 140;
      const FLOATING_MENU_BUTTON_HEIGHT = 38;
      const BOTTOM_BUFFER = 16;

      const targetRect = target.getBoundingClientRect();
      const bottomSpaceOfTarget =
        window.innerHeight - targetRect.bottom - BOTTOM_BUFFER;
      const visibleItems = this.floatingMenuProps.items.filter(
        item => item.isVisible
      );
      const floatingMenuTotalHeight =
        FLOATING_MENU_ARROW_MARGIN +
        FLOATING_MENU_ARROW_HEIGHT +
        FLOATING_MENU_CONTENT_PADDING +
        FLOATING_MENU_BUTTON_HEIGHT * visibleItems.length;

      this.floatingMenuProps.position.x =
        targetRect.left +
        targetRect.width / 2 -
        FLOATING_MENU_CONTENT_WIDTH / 2;

      if (bottomSpaceOfTarget > floatingMenuTotalHeight) {
        this.floatingMenuProps.position.y =
          targetRect.bottom +
          FLOATING_MENU_ARROW_HEIGHT +
          FLOATING_MENU_ARROW_MARGIN;
        this.floatingMenuProps.vertexDirection = "top";
      } else {
        this.floatingMenuProps.position.y =
          targetRect.top - floatingMenuTotalHeight;
        this.floatingMenuProps.vertexDirection = "bottom";
      }
    },
    handleEventClickMenu(value) {
      this.$emit("click", value, this.studentId, this.name, this.course);
      this.floatingMenuProps.isVisible = !this.floatingMenuProps.isVisible;
    },
    getVisibleFloatingMenuItems() {
      return this.floatingMenuProps.items.filter(option => option.isVisible);
    }
  }
});
